// Navigation des Moduls `goals` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul goals.
import { ChartLineUp, CheckSquare, Target, WebhooksLogo } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'goals',
  title: 'Goals & KPIs',
  nav: {
    people: [
      {
        key: 'goals.performance',
        label: 'Performance',
        icon: ChartLineUp,
        path: '/goals',
        roles: ['ALL'],
        order: 40,
        area: 'rail',
        activeFor: ['/reviews', '/promotions', '/framework', '/insights'],
      },
      {
        key: 'goals.tab',
        label: 'Goals',
        icon: Target,
        path: '/goals',
        roles: ['ALL'],
        order: 10,
        area: 'tabs:performance',
      },
    ],
    admin: [
      {
        key: 'goals.admin',
        label: 'Goals overview',
        icon: Target,
        path: '/performance/goals',
        roles: ['ADM', 'PERF', 'CL', 'CEO'],
        order: 250,
        area: 'Performance',
      },
      {
        key: 'goals.kpiqa',
        label: 'KPI QA',
        icon: CheckSquare,
        path: '/performance/kpi-qa',
        roles: ['ADM', 'PERF'],
        order: 260,
        area: 'Performance',
      },
      {
        key: 'goals.webhooks',
        label: 'KPI webhooks',
        icon: WebhooksLogo,
        path: '/performance/kpi-webhooks',
        roles: ['ADM', 'PERF'],
        order: 270,
        area: 'Performance',
      },
    ],
  },
});
